/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_SkipInputs */

const en_us2_workout_skip = /** @type {(inputs: Workout_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skip`)
};

const pt_br2_workout_skip = /** @type {(inputs: Workout_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pular`)
};

const es_419_workout_skip = /** @type {(inputs: Workout_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saltar`)
};

const pt_pt2_workout_skip = /** @type {(inputs: Workout_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saltar`)
};

const fr_fr2_workout_skip = /** @type {(inputs: Workout_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passer`)
};

const de_de2_workout_skip = /** @type {(inputs: Workout_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überspringen`)
};

const it_it2_workout_skip = /** @type {(inputs: Workout_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salta`)
};

/**
* | output |
* | --- |
* | "Skip" |
*
* @param {Workout_SkipInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_skip = /** @type {((inputs?: Workout_SkipInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_SkipInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_skip(inputs)
	if (locale === "es-419") return es_419_workout_skip(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_skip(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_skip(inputs)
	if (locale === "de-DE") return de_de2_workout_skip(inputs)
	if (locale === "it-IT") return it_it2_workout_skip(inputs)
	return en_us2_workout_skip(inputs)
});
export { workout_skip as "workout.skip" }